import ProductShot from "./visuals/ProductShot";

interface ProductVisualProps {
  variant: "chat" | "phone" | "workspace";
  name: string;
  caption?: string;
}

export default function ProductVisual({ variant, name, caption }: ProductVisualProps) {
  if (variant === "phone") {
    return (
      <ProductShot
        src="https://joble.app/images/Frame-2.svg"
        alt="Joble AI Phone Agent handling an incoming call"
        title="Joble AI Phone Agent"
        caption={caption}
      />
    );
  }

  if (variant === "workspace") {
    return (
      <ProductShot
        src="https://joble.app/images/Frame-3.svg"
        alt="Joble Workspace dashboard showing conversations, calls and bookings"
        title="Joble Workspace"
        caption={caption}
      />
    );
  }

  return (
    <ProductShot
      src="https://joble.app/images/Frame-1.svg"
      alt={`Joble AI Web Agent conversation with ${name}`}
      title="Joble AI Web Agent"
      caption={caption}
    />
  );
}